
import { computed, defineComponent, onBeforeMount } from "vue";
import UserStatistics from "../components/application/userStatistics/UserStatistics.vue";
import { isCirculoTemplate, scrollToTop } from "../components/mixins";
import UserEvents from "../components/application/userEvents/UserEvents.vue";
import UserCourses from "../components/application/UserCourses.vue";
import router from "@/routes";
import TrainingIndication from "../components/application/Indication/TrainingIndication.vue";
import FavoriteTraining from "../components/application/favorites/FavoriteTraining.vue";
import UserTracks from "../components/application/UserTracks.vue";

type Option = {
  name: string;
  param: string;
  visible?: boolean | (() => boolean);
};

export default defineComponent({
  name: "UserStatisticsView",
  components: {
    UserTracks,
    FavoriteTraining,
    TrainingIndication,
    UserStatistics,
    UserEvents,
    UserCourses
  },
  setup() {
    onBeforeMount(async () => {
      scrollToTop();
    });

    /** List of tabs available in the down section of the profile page. */
    const options: Option[] = [
      { name: "Estatísticas", param: "chart" },
      { name: "Trilhas obrigatórias", param: "tracks" },
      { name: "Treinamentos", param: "courses" },
      { name: "Eventos", param: "events", visible: !isCirculoTemplate() },
      { name: "Treinamentos recomendados", param: "indication" },
      { name: "Treinamentos favoritos", param: "favorite" }
    ];

    /** Computed property for filtered options (visible only) */
    const visibleOptions = computed(() => {
      return options.filter(option => option.visible !== false);
    });

    const navigateToOption = (event: Event): void => {
      const selectedOption = (event.target as HTMLSelectElement).value;
      router.push({ name: "statistics", params: { option: selectedOption } });
    };

    const selectedOption = computed(() => {
      return router.currentRoute.value.params.option || "chart";
    });

    return {
      options,
      navigateToOption,
      visibleOptions,
      selectedOption
    };
  }
});
